import { User } from 'src/app/shared/models/user';
import { AuthenticationError } from './authentication-error';
import { GDPRAgreement } from 'src/app/shared/models/gdpr-agreement';

export class AuthenticationResult {
	public success: boolean;
  public user: User;
  public error: AuthenticationError;
  public gdprAgreementContent: GDPRAgreement;
}
